import appSettings from '../appSettings';

export interface IError {
    errorMessage?: string;
    errorKey?: string;
}

export function getMessage(error: IError) {
    if (error.errorKey) {
        switch (error.errorKey) {
            case 'errors.account.retrival.out':
                return `Password retrieval attempts exceeded. Please call ${appSettings.SmarTripRegionalCustomerServiceCenterPhone}`;
        }
    }

    return error.errorMessage || `Error occured. Please, call RCSC at ${appSettings.SmarTripRegionalCustomerServiceCenterPhone} for support`;
}


// WEBPACK FOOTER //
// ./src/services/errorService.ts